
import { useChartResources } from '@chart';

export default function() {
    return useChartResources('Bar');
}